import _ from 'lodash';

const moduleName = 'ProspectingProjectGrant';
const modulePath = _.kebabCase(moduleName);

export default {
  moduleName,
  modulePath,
};
